import { useTranslation } from 'react-i18next'
import { Icon } from '../ui/icon'

interface InfoModalProps {
  isOpen: boolean
  onClose: () => void
}

export const InfoModal = ({ isOpen, onClose }: InfoModalProps) => {
  const { t } = useTranslation()

  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-[80] flex items-center justify-center bg-black/50" onClick={onClose}>
      <div className="bg-bg-surface rounded-2xl shadow-2xl border border-border-default w-full max-w-lg mx-4 max-h-[80vh] flex flex-col" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-border-default">
          <h2 className="text-lg font-semibold text-fg-primary">{t('info.title')}</h2>
          <button onClick={onClose} className="rounded-full p-1.5 text-fg-muted hover:text-fg-primary hover:bg-interactive-hover transition-colors">
            <Icon icon="x" size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-6 py-4 space-y-6">
          <section>
            <div className="flex items-center gap-4 mb-4">
              <div className="w-14 h-14 rounded-2xl bg-accent flex items-center justify-center text-white text-2xl font-bold">O</div>
              <div>
                <h3 className="text-base font-semibold text-fg-primary">OpakorPDF</h3>
                <p className="text-xs text-fg-muted">{t('info.version')} 1.0.0</p>
              </div>
            </div>
            <p className="text-xs text-fg-muted leading-relaxed">{t('info.description')}</p>
          </section>

          <section>
            <h3 className="text-sm font-semibold text-fg-primary mb-3">{t('info.technologies')}</h3>
            <div className="space-y-1 text-xs text-fg-muted">
              <p>EmbedPDF — {t('info.embedpdfDesc')}</p>
              <p>ONNX Runtime Web — {t('info.onnxDesc')}</p>
              <p>Opakor OCR — {t('info.ocrDesc')}</p>
            </div>
          </section>

          <section>
            <h3 className="text-sm font-semibold text-fg-primary mb-3">{t('info.privacy')}</h3>
            <div className="space-y-2 text-xs text-fg-muted leading-relaxed">
              <p>{t('info.privacyNoTracking')}</p>
              <p>{t('info.privacyLocalStorage')}</p>
              <p>{t('info.privacyNoServer')}</p>
            </div>
          </section>

          <section>
            <h3 className="text-sm font-semibold text-fg-primary mb-3">{t('info.terms')}</h3>
            <div className="space-y-2 text-xs text-fg-muted leading-relaxed">
              <p>{t('info.termsDisclaimer')}</p>
              <p>{t('info.termsLicense')}</p>
            </div>
          </section>

          <section>
            <h3 className="text-sm font-semibold text-fg-primary mb-3">{t('info.contact')}</h3>
            <p className="text-xs text-fg-muted leading-relaxed">{t('info.contactText')}</p>
          </section>
        </div>
      </div>
    </div>
  )
}
